import { BaseGTMRunner } from "../BaseGTM/BaseGTMRunner";

let instance: GTMEVARunner | null = null;
const pendingEvents: Event[] = [];

export class GTMEVARunner extends BaseGTMRunner {
  constructor() {
    super();
    this.trackCustomEvents();
    this.trackMessageBusEvents();
  }

  initialize(gtmContainer: HTMLElement | null, pageType: string) {
    this.gtmContainer = gtmContainer;
    this.isCartPage = pageType === "cart";
    this.isLoyaltyPage = pageType === "loyalty";
    this.onLoadTracking = undefined;

    if (this.gtmContainer) {
      this.onLoadTracking = this.gtmContainer.dataset.onLoadTracking;
      const code = this.gtmContainer.dataset.gtmCode;
      this.currentName = this.getCurrentNameForGtm();

      if (code && this.currentName) {
        this.instance = null;
        this.handleHashChange();
      }
    }
  }

  static override getInstance(gtmContainer: HTMLElement | null = null, pageType: string = "other") {
    if (!instance) {
      instance = new GTMEVARunner();
    }
    instance.initialize(gtmContainer, pageType);
    this.dispatchPendingEvents();

    return instance;
  }

  static get isReadyToAcceptEvents() {
    if (!instance) {
      return false;
    }
    return instance.instance?.isReady && instance.customEventsRegistered;
  }

  static dispatchEvent(event: Event): void {
    if (!instance) {
      pendingEvents.push(event);
      return;
    }

    document.dispatchEvent(event);
  }

  private static dispatchPendingEvents(): void {
    pendingEvents.splice(0).forEach((event) => document.dispatchEvent(event));
  }
}
